import swal from 'sweetalert'
import Mousetrap from 'mousetrap'

angular
  .module('deskfy.arts')
  .controller('TemplateItemController', TemplateItemController)

/* @ngInject */
function TemplateItemController ($scope, $state, $attrs, $translate, $timeout, $rootScope, $q, $location, ArtsService, ArtCollectionsService, CONSTANTS, Utils, ModalService, UdsModalService, MessageService, ToastService, TemplateService, SegmentService, AssetPreviewService, SocialMediaService, ConfirmationModalService, CampaignService, ShareLinkService) {
  const getDownloadDialogController = () => $q.when(import('../../dialogs/download/download-dialog.controller'))
  const getApprovalDialogController = () => $q.when(import('../../dialogs/approval/approval-dialog.controller'))
  const getMergeArtsDialogController = () => $q.when(import('../../dialogs/merge-arts/merge-arts-dialog.controller'))
  const getMoveTemplateCollectionController = () => $q.when(import('../../dialogs/move-template-collection/move-template-collection-dialog.controller'))
  const getMoveArtToFolderController = () => $q.when(import('../../dialogs/move-art-to-folder/move-art-to-folder-dialog.controller'))
  const getShareArtDialogController = () => $q.when(import('../../dialogs/share-art/share-art-dialog.controller'))
  const getTemplateSuggestionsDialogController = () => $q.when(import('../../dialogs/template-suggestions/template-suggestions-dialog.controller'))
  const getOutdatedTemplateDialogController = () => $q.when(import('../../dialogs/outdated-template/outdated-template-dialog.controller'))
  const getUnavailableTemplateDialogController = () => $q.when(import('../../dialogs/unavailable-template/unavailable-template-dialog.controller'))
  const getUseTermsListDialogController = () => $q.when(import('../../dialogs/use-terms/list/use-terms-list-dialog.controller'))
  const getUnarchiveTemplateDialogController = () => $q.when(import('../../dialogs/unarchive-template/unarchive-template-dialog.controller'))
  const getUnarchiveArtWarningDialogController = () => $q.when(import('../../dialogs/unarchive-art-warning/unarchive-art-warning-dialog.controller'))
  const getTemplatePropertiesDialogController = () => $q.when(import('../../dialogs/template-properties/template-properties-dialog.controller'))
  const getSocialMediaLinkAccountDialogController = () => $q.when(import('../../dialogs/social-media-link-account/social-media-link-account.controller'))

  $scope.defaultThumb = false
  $scope.buttons = {}
  $scope.agreeUseTerms = false
  $scope.showCustomizableTag = angular.isDefined($scope.showCustomizableTag) ? $scope.showCustomizableTag : true
  $scope.backgroundImage = ''
  $scope.isWrapButton = false
  $scope.userIsSysAdminAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()

  const videoExtensions = ['avi', 'ktime', 'mpeg', 'x-m4v', 'mp4', 'mov', 'mkv', 'rmvb']
  const api = {
    getTemplatePropertiesDialogController,
    getDownloadDialogController,
    getApprovalDialogController,
    getMergeArtsDialogController,
    getMoveTemplateCollectionController,
    getMoveArtToFolderController,
    getShareArtDialogController,
    getTemplateSuggestionsDialogController,
    getUseTermsListDialogController,
    getUnarchiveTemplateDialogController,
    getOutdatedTemplateDialogController,
    getUnavailableTemplateDialogController,
    getUnarchiveArtWarningDialogController,
    getSocialMediaLinkAccountDialogController,
    _defineButtons,
    _sendArtToDesigning,
    _isInCompanyTemplates,
    _isInPlusTemplatesOrCollection,
    _isInMyTemplates,
    _moveToClick,
    _moveArtToFolder,
    _unarchiveArt,
    _archiveArt,
    _isOutdated,
    _showOutdatedDialog,
    _showUnavailableDialog,
    _getPreviewAssets,
    _openSocialMediaLinkAccountDialog,
    _bindTemplateToCampaign,
    _unbindTemplateFromCampaign,
    _isBluefitDesigner,
    _initObserverTemplate,
    _applyWrapButtons
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._initObserverTemplate($scope.template)
    api._defineButtons()
    api._applyWrapButtons()
  }

  $scope.showScheduleDate = function (template) {
    if (!template.templateScheduleDate) return false
    const scheduleDate = new Date(template.templateScheduleDate)
    const now = new Date()
    if (template.templateScheduleDate && scheduleDate > now) {
      return true
    }
    return false
  }

  $scope.showExpirationDate = function (template) {
    if (!template.templateExpirationDate) return false
    const expirationDate = new Date(template.templateExpirationDate)
    const now = new Date()
    if (template.templateExpirationDate && expirationDate >= now) {
      return true
    }
    return false
  }

  $scope.getThumbUrl = function (template) {
    const isImage = template.thumbnailContentType ? template.thumbnailContentType.toLowerCase().includes('image') : false
    const isPdf = template.thumbnailContentType ? template.thumbnailContentType.toLowerCase().includes('pdf') : false

    if (!isImage && !isPdf && !template.isCustomizable) {
      $scope.defaultThumb = true
      return TemplateService.getDefaultThumbnail(template.extension)
    }

    if ($scope.isPublicCampaign) {
      return ShareLinkService.getThumbnailShareLink(template.id, $scope.linkUuid)
    } else {
      return AssetPreviewService.getArtPreview(template.id)
    }
  }

  function _initObserverTemplate (template) {
    const templateElement = $attrs.$$element.find('.thumbnail-container')

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.4
    }

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          $timeout(() => {
            $scope.backgroundImage = $scope.getThumbUrl(template)
          }, 500, true)
        }
      })
    }

    const observer = new IntersectionObserver(observerCallback, options)

    if (templateElement[0]) {
      observer.observe(templateElement[0])
    }
  }

  $scope.goToCustomize = function (template) {
    $state.go('customizeArt', {
      idArt: template.id,
      hideConvertTemplateButton: false,
      from: $state.current.name,
      fromParams: $state.params
    })
  }

  $scope.downloadTemplateClick = function (template) {
    if (template.needApproval && template.approvalStatus !== 'APPROVED' && $rootScope.isUser()) {
      ToastService.showErrorToast($translate.instant('pendingApprovalErrorMsg'))
      return
    }
    if (template.linkedTemplates && template.linkedTemplates.length > 0) {
      api.getMergeArtsDialogController().then(({ MergeArtsDialogController }) => {
        ModalService.showModal({
          templateId: 'mergeArtsDialog.html',
          templateUrl: '/arts/dialogs/merge-arts/merge-arts-dialog.html?$$REVISION$$',
          destroyable: true,
          controller: MergeArtsDialogController,
          data: {
            template,
            linkedTemplates: template.linkedTemplates.slice()
          }
        })
      })
    } else if (template.isTemplate && !template.isCustomizable) {
      $scope.downloading = true

      if (template.useTermsId && !$scope.agreeUseTerms) {
        ModalService.close()
        api.getUseTermsListDialogController().then(({ UseTermsListDialogController }) => {
          ModalService.showModal({
            templateId: 'useTermsListDialog.html',
            templateUrl: '/arts/dialogs/use-terms/list/use-terms-list-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: UseTermsListDialogController,
            data: {
              useTermId: template.useTermsId,
              artId: template.id,
              useType: 'DOWNLOAD'
            }
          }).then(agreeTerms => {
            if (agreeTerms) {
              $scope.agreeUseTerms = true
              $scope.downloadTemplateClick(template)
            }
          })
        })
        return
      }

      $q.all([
        ArtsService.getArtDetailById(template.id),
        ArtsService.getInfosBusinessData(template.id)
      ]).then(([art, businessDataInfo]) => {
        const place = $state.current.name

        if (art.campaignId) {
          SegmentService.track('download-art', { campaign_id: art.campaignId })
        } else {
          const productValue = !!document.querySelector('#canvas_group [data-product]')
          SegmentService.track('downloaded-art', {
            art_id: template.id,
            photoframes: 0,
            permission: 'download',
            type: 'only_download',
            template_id: art.baseTemplateId,
            place,
            element_hyperlink: art.hyperlinks,
            format_type: template?.productType?.toLowerCase?.(),
            business_data: businessDataInfo.hasPlaceholdersSaved,
            video: art.hasVideo,
            product: productValue
          })
        }
      })

      let file = null
      let url = ''

      if ($scope.isPublicCampaign) {
        url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_SHARE_LINKS_DOWNLOAD_ART_PUBLIC_FOLDER, [template.id, $scope.linkUuid])
        file = Utils.downloadFile(url, {
          artId: template.id
        })
      } else {
        url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_DOWNLOAD, [template.id])
        file = Utils.downloadFile(url, {
          artId: template.id
        })
      }

      ToastService.showSuccessToast($translate.instant('successDownloadFile'))

      $scope.downloading = false
      if (template.suggestions) {
        api.getTemplateSuggestionsDialogController().then(({ TemplateSuggestionsDialogController }) => {
          ModalService.showModal({
            templateId: 'templateSuggestions.html',
            templateUrl: '/arts/dialogs/template-suggestions/template-suggestions-dialog.html?$$REVISION$$',
            controller: TemplateSuggestionsDialogController,
            destroyable: true,
            data: {
              _sSuggestions: template.suggestions,
              _bIsPrintInstruction: template.product && template.product.type === 'PRINTABLE'
            }
          })
        })
      }
      return file
    } else {
      api.getDownloadDialogController().then(({ DownloadDialogController }) => {
        const downloadDialog = UdsModalService.createModal({
          controller: DownloadDialogController,
          modalName: 'downloadDialog',
          data: {
            _iArtId: template.id,
            _customizationLevel: template.customizationLevel,
            _isCustomizable: template.isCustomizable,
            _sDownloadOption: template.downloadOption,
            _iProductId: template.productId,
            _oTemplate: Object.assign({}, template, {
              details: {
                instructions: template.instructions,
                suggestions: template.suggestions
              }
            })
          }
        })

        downloadDialog.open()
      })
    }
  }

  $scope.openAssetPreview = (template, location) => {
    AssetPreviewService.openAssetPreview({
      asset: template,
      location: $scope.isPublicCampaign ? 'public-campaign' : location,
      fromCampaignAction: $scope.fromCampaignAction,
      publicCampaign: $scope.isPublicCampaign,
      allTemplates: $scope.isPublicCampaign ? $scope.allTemplates : null,
      linkUuid: $scope.linkUuid,
      getPreviewAssets: $scope.getPreviewAssets ? $scope.getPreviewAssets : () => {
        return Promise.resolve({
          count: 0,
          rows: []
        })
      },
      onMoveAsset: (asset) => {
        api._moveArtToFolder(asset)
      }
    })
  }

  $scope.handleDoubleClickOnCard = (template) => {
    if ($scope.validateDoubleClickEnabled()) {
      $scope.openAssetPreview(template, $scope.location)
    }
  }

  $scope.validateDoubleClickEnabled = () => {
    return Boolean($scope.showPreviewButton)
  }

  $scope.getIcon = () => {
    if ($scope.template?.hasVideo) {
      return 'play'
    } else if ($scope.template?.isCustomizable) {
      return 'edit'
    } else if ($scope.template?.extension && videoExtensions.indexOf($scope.template.extension.toLowerCase()) !== -1) {
      return 'play'
    }

    return 'image'
  }

  $scope.openShareDialog = function (template) {
    api.getShareArtDialogController().then(({ ShareArtDialogController }) => {
      const shareArtDialog = UdsModalService.createModal({
        controller: ShareArtDialogController,
        modalName: 'shareArtDialog',
        data: {
          art: template
        },
        onClose: (shared) => {
          if (shared && template.temporarilyAvailable[0]) {
            ArtsService.updateTemporarilyAvailableArt(template.id, { shared: true })
          }
        }
      })

      shareArtDialog.open()
    })
  }

  $scope.archiveTemplateClick = function (template) {
    if (template.isArchived || $scope.view === 'userArchivedArts') {
      const message = template.isTemplate
        ? $translate.instant('areYouSureUnarchiveTemplate')
        : $translate.instant('confirmUnarchiveArt')

      if (template?.isTemplate && template?.isCustomizable) {
        api.getUnarchiveTemplateDialogController().then(({ unarchiveTemplateController }) => {
          ModalService.showModal({
            templateId: 'unarchiveTemplate.html',
            templateUrl: '/arts/dialogs/unarchive-template/unarchive-template-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: unarchiveTemplateController,
            data: {
              data: {
                template
              }
            }
          })
        })
        return
      }

      if (template.unavailable && !$rootScope.isUserSysAdminAdminDesigner()) {
        api.getUnarchiveArtWarningDialogController().then(({ UnarchiveArtWarningDialogController }) => {
          ModalService.showModal({
            templateId: 'unarchiveArtWarning.html',
            templateUrl: '/arts/dialogs/unarchive-art-warning/unarchive-art-warning-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: UnarchiveArtWarningDialogController
          })
        })
      } else {
        MessageService.warning({
          title: $translate.instant('beware'),
          text: message,
          confirmButton: $translate.instant('unarchive'),
          cancelButton: $translate.instant('cancel'),
          closeOnConfirm: true,
          showLoaderOnConfirm: true,
          allowOutsideClick: true,
          press: () => {
            api._unarchiveArt(template)
          }
        })
      }
    } else {
      let message

      if (!template.isTemplate) {
        message = $translate.instant('areYouSureArchiveArt')
      } else {
        message = template.isCustomizable ? $translate.instant('archiveTemplateDialogText') : $translate.instant('areYouSureArchiveTemplate')
      }

      const modalConfig = {
        title: $translate.instant('archive'),
        buttonCancelText: $translate.instant('cancel'),
        buttonConfirmText: $translate.instant('campaignEdit.archiveConfirm.confirm'),
        onConfirm: () => {
          api._archiveArt(template)
        }
      }

      if (template.campaignId && template.isTemplate) {
        modalConfig.htmlDescription = CampaignService.getArchiveHtmlDescription(template.campaignName)
      } else {
        modalConfig.description = message
      }

      ConfirmationModalService.createModal(modalConfig)
    }
  }

  $scope.openEditor = function (template) {
    if (!$rootScope.isDesktop && template.customizationLevel !== 'ONLY_DOWNLOAD') {
      $scope.showMobileDialog()
      return
    }

    if (template.approvalStatus === 'APPROVED' && $rootScope.isUser()) {
      $scope.cloneArt(template)
      return
    }

    if (template.isTemplate) {
      $scope.$emit('campaign.close-action-materials-dialog')
      $state.go('customizeTemplate', {
        from: $state.current.name,
        fromParams: $state.params,
        templateId: template.id
      })
    } else {
      if (template.needApproval && template.approvalStatus === 'APPROVED' && $rootScope.isUser()) {
        MessageService.warning({
          title: $translate.instant('warning'),
          text: $translate.instant('editApprovedArtMsg'),
          confirmButton: $translate.instant('edit'),
          cancelButton: $translate.instant('cancel'),
          press: api._sendArtToDesigning(template),
          allowOutsideClick: false,
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        })
        return
      }

      $state.go('customizeArt', {
        idArt: template.id,
        from: $state.current.name,
        fromParams: $state.params
      })
    }
  }

  $scope.cloneArt = function (art) {
    $scope.loading = true
    ArtsService.cloneArt(art.id)
      .then((response) => {
        $scope.openEditor(response)
      })
      .catch(ToastService.defaultErrorToast)
      .finally(() => {
        $scope.loading = false
      })
  }

  $scope.showConvertTemplateDialog = function (art) {
    api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
      const templatePropertiesDialog = UdsModalService.createModal({
        controller: TemplatePropertiesDialogController,
        modalName: 'templatePropertiesDialog',
        data: {
          art: art,
          shouldConvertToTemplate: true,
          isCustomizable: art.isCustomizable,
          artCollectionId: art.artCollectionId
        },
        onClose: (info) => {
          if (info && info.wasPublished) {
            if (info.artCollectionId) {
              ArtCollectionsService.find(info.artCollectionId).then(res => {
                if (!res.parentId && !res.highlighted) {
                  $state.go('arts.templates', {}, { reload: true })
                } else {
                  $state.go('arts.collection', { id: info.artCollectionId })
                }
              })
            } else {
              $state.go('arts.companyTemplates')
            }
          }
        }
      })

      templatePropertiesDialog.open()
    })
  }

  $scope.showMobileDialog = function () {
    MessageService.error({
      title: $translate.instant('oopsTitle'),
      text: $translate.instant('mobileCustomizeNotAllowed') + '\n\n' + $translate.instant('continueWorkOnPC'),
      confirmButtonText: $translate.instant('ok')
    })
  }

  $scope.moveToClick = api._moveToClick
  $scope.moveArtToFolder = api._moveArtToFolder

  $scope.openTemplateSettings = function (event, template) {
    event.stopPropagation()
    Mousetrap.unbind('space')

    api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
      const templatePropertiesDialog = UdsModalService.createModal({
        controller: TemplatePropertiesDialogController,
        modalName: 'templatePropertiesDialog',
        data: {
          art: {
            ...template,
            layers: template.art_layers
          },
          isEditing: true,
          shouldConvertToTemplate: false,
          isCustomizable: template.isCustomizable,
          artCollectionId: template.artCollectionId
        },
        onClose: (info) => {
          Mousetrap.bind('space', (event) => $scope.handleOpenQuickPreview({ event }))

          $location.search({ ...$state.params, id: null, template: null })

          if ($scope.templateParam) {
            $scope.templateParam.id = template.id
          }

          if (info && info.wasUpdated && !$scope.isProductList) {
            $scope.$emit('reload-arts-page')
          } else if (info && info.wasUpdated && $scope.isProductList) {
            $scope.$emit('refresh-arts-page', { sectionId: template.artCollectionId })
          }
        }
      })

      templatePropertiesDialog.open()
    })
  }

  $scope.showDownloadButton = function (template) {
    const isApproved = template.approvalStatus === 'APPROVED'
    const isAvailable = !template.unavailable

    if (api._isInCompanyTemplates()) {
      return false
    }

    if ($scope.location === 'addMaterialsModal') {
      return false
    }

    if (api._isInPlusTemplatesOrCollection() && $rootScope.isUserSysAdminAdminDesigner()) {
      return false
    }

    if (!isApproved && template.needApproval && $rootScope.isUser()) {
      return false
    }

    return (
      !template.isCustomizable ||
        template.customizationLevel === 'ONLY_DOWNLOAD' ||
        (!template.needApproval && $rootScope.isUser() && !template.isTemplate) ||
        (template.isCustomizable && $rootScope.isUserSysAdminAdminDesigner()) ||
        ($rootScope.oUserCompanyConfigurations.ENABLE_DOWNLOAD_APPROVED_ART && isApproved && !template.isTemplate)
    ) && !template.isArchived && isAvailable
  }

  $scope.formatDate = (dateISO = new Date()) => {
    const configOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }

    const locale = $rootScope.oUser.locale
    const date = new Date(dateISO)
    const formattedDate = new Intl.DateTimeFormat(locale, configOptions).format(date)
    return formattedDate.replace(/ de /g, ' ')
  }

  $scope.showSettingsButton = function (template) {
    return (api._isInCompanyTemplates() || api._isInPlusTemplatesOrCollection()) && $rootScope.isUserSysAdminAdminDesigner() && !template.isCustomizable
  }

  $scope.showDuplicateButton = function (template) {
    if (!api._isInPlusTemplatesOrCollection() || !$rootScope.isUserSysAdminAdminDesigner()) {
      return false
    }

    if ($scope.view === 'userArchivedArts') {
      return false
    }

    return $scope.options.duplicate && (template.isCustomizable && (template.approvalStatus !== 'REJECTED' || template.unavailable))
  }

  $scope.showCustomizeDuplicateButton = function (template) {
    if (api._isInPlusTemplatesOrCollection()) {
      return false
    }

    if ($scope.view === 'userArchivedArts') {
      return false
    }

    return $scope.options.duplicate && template.isCustomizable && template.approvalStatus !== 'REJECTED' && !template.unavailable
  }

  $scope.showCustomizeButton = function (template) {
    if (api._isBluefitDesigner()) return false

    if ($scope.location === 'campaign') {
      return false
    }

    if (template.isArchived) {
      return false
    }

    if ((api._isInPlusTemplatesOrCollection() || api._isInMyTemplates()) && $rootScope.isUserSysAdminAdminDesigner()) {
      return false
    }

    const pendingApprovalOrRework = template.needApproval && (template.approvalStatus === 'PENDING_APPROVAL' || template.approvalStatus === 'PENDING_REWORK' || template.approvalStatus === 'DESIGNING')
    const noApprovalNeeded = !template.needApproval
    const onlyDownload = template.customizationLevel === 'ONLY_DOWNLOAD' && $rootScope.isUser()

    return $scope.actions && template.isCustomizable && !template.isArchived && !onlyDownload && (pendingApprovalOrRework || $rootScope.isUserSysAdminAdminDesigner() || noApprovalNeeded)
  }

  $scope.showEditButton = function (template) {
    if (api._isBluefitDesigner()) return false
    return ((api._isInCompanyTemplates() || ((api._isInPlusTemplatesOrCollection() || api._isInMyTemplates()) && $rootScope.isUserSysAdminAdminDesigner())) && template.isCustomizable && $rootScope.isDesktop && !template.unavailable && !template.isArchived)
  }

  $scope.openBindCampaignDialog = (template) => {
    const onClose = (bindDetails) => {
      if (bindDetails) {
        if (bindDetails.selectedCampaignId) {
          api._bindTemplateToCampaign(bindDetails)
        } else {
          api._unbindTemplateFromCampaign(bindDetails, template.campaignId)
        }
      }
    }

    CampaignService.openUnbindCampaignDialog(template, 'arts', onClose)
  }

  $scope.showSocialMediaButton = (template) => {
    if ($scope.location === 'addMaterialsModal') {
      return false
    }

    const isUser = $rootScope.isUser()
    const isEnableSocialMedia = $rootScope.isEnableSocialMedia

    return SocialMediaService.showSocialButton(template, isUser, isEnableSocialMedia, false)
  }

  $scope.openSocialMediaPost = (template) => {
    const hasNotUserAccounts = !$rootScope?.oUser?.socialAccounts?.length

    if (hasNotUserAccounts) {
      return api._openSocialMediaLinkAccountDialog()
    }

    const templateId = template.id

    $state.go('arts.socialMedia', {
      templateIds: [templateId]
    })
  }

  function _openSocialMediaLinkAccountDialog () {
    api.getSocialMediaLinkAccountDialogController().then(({ SocialMediaLinkAccountController }) => {
      const socialMediaLinkedDialog = UdsModalService.createModal({
        controller: SocialMediaLinkAccountController,
        modalName: 'socialMediaLinkAccountDialog'
      })

      socialMediaLinkedDialog.open()
    })
  }

  function _bindTemplateToCampaign (bindDetails) {
    ArtsService.bindTemplateToCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        if ($scope.isProductList) {
          $scope.$emit('refresh-arts-page', { sectionId: $scope.template.artCollectionId })
        } else {
          $scope.$emit('reload-arts-page')
        }
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _unbindTemplateFromCampaign (bindDetails, campaignId) {
    ArtsService.unbindTemplateFromCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        if ($scope.isProductList) {
          $scope.$emit('refresh-arts-page', { sectionId: $scope.template.artCollectionId })
        } else {
          $scope.$emit('reload-arts-page', { campaignId })
        }
        if ($scope.location === 'campaign') {
          $scope.$emit('campaign.reload-actions')
        }
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _getPreviewAssets () {
    return Promise.resolve({
      assets: $scope.arts,
      count: $scope.arts.length
    })
  }

  function _defineButtons () {
    if ($scope.options) {
      const isApprovedArt = ($scope.template.approvalStatus === 'APPROVED' && $scope.template.needApproval)
      const isAvailable = !$scope.template.unavailable
      const isApprovedValidation = (isApprovedArt || !$scope.template.needApproval || $scope.template.customizationLevel === 'ONLY_DOWNLOAD' || !$scope.template.isCustomizable)
      const isArchived = $scope.template.isArchived
      const needApproval = $scope.template.needApproval

      $scope.buttons.edit = isAvailable && !isArchived && $scope.template.isCustomizable && $rootScope.isDesktop && $scope.options.edit && $rootScope.isUserSysAdminAdminDesigner() && !api._isInPlusTemplatesOrCollection()
      $scope.buttons.move = $scope.options.move && $rootScope.isUserSysAdminAdminDesigner()
      $scope.buttons.download = isAvailable && !isArchived && ($scope.options.edit || $scope.options.download) && (($scope.template.isCustomizable && $rootScope.isUserSysAdminAdminDesigner()) || !$scope.template.isCustomizable)
      $scope.buttons.share = isAvailable && !isArchived && ($scope.options.share && $scope.view !== 'userArchivedArts' && (($rootScope.isUser() && isApprovedValidation) || $rootScope.isUserSysAdminAdminDesigner())) && !$scope.template.isTemplate
      $scope.buttons.archive = $scope.options.archive && ($rootScope.isUserSysAdminAdminDesigner() || $scope.template.ownerId === $rootScope.oUser.id)
      $scope.buttons.publish = $scope.options.publish && !$scope.template.isTemplate && $rootScope.isUserSysAdminAdminDesigner() && $scope.view !== 'userArchivedArts'
      $scope.buttons.customize = $scope.options.customize && isAvailable && $scope.template.isCustomizable && !isArchived && $rootScope.isDesktop && $rootScope.isUser() && (isApprovedArt || !needApproval)
    }
  }

  function _sendArtToDesigning (art) {
    return function () {
      ArtsService.sendArtToDesiging(art.id).then(function () {
        swal.close()
        $state.go('customizeArt', {
          idArt: art.id,
          from: $state.current.name,
          fromParams: $state.params
        })
      })
    }
  }

  function _isInCompanyTemplates () {
    return $state.current.name === 'arts.companyTemplates'
  }

  function _isInPlusTemplatesOrCollection () {
    return $state.current.name === 'arts.templates' || $state.current.name === 'arts.collection'
  }

  function _isInMyTemplates () {
    return $state.current.name === 'arts.me'
  }

  function _moveToClick (template, skipEventEmit, isUnarchiving = false) {
    return api.getMoveTemplateCollectionController().then(({ MoveTemplateCollectionController }) => {
      return ModalService.showModal({
        templateId: 'moveTemplateCollection.html',
        templateUrl: '/arts/dialogs/move-template-collection/move-template-collection-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: MoveTemplateCollectionController,
        data: {
          data: template,
          type: 'template',
          isUnarchiving
        }
      }).then(info => {
        if (info && info.changed && !skipEventEmit && !$scope.isProductList) {
          $scope.$emit('reload-arts-page', { emitter: 'moveTemplate', ...info })
        } else if (info && info.changed && !skipEventEmit && $scope.isProductList) {
          $scope.$emit('refresh-arts-page', { sectionId: info.in, targetId: info.to })
        }

        return info?.changed
      })
    })
  }

  function _moveArtToFolder (template) {
    return api.getMoveArtToFolderController().then(({ MoveArtToFolderController }) => {
      return ModalService.showModal({
        templateId: 'moveArtToFolderController.html',
        templateUrl: '/arts/dialogs/move-art-to-folder/move-art-to-folder-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: MoveArtToFolderController,
        data: {
          templates: [template]
        }
      }).then(info => {
        if (info && info.changed && !$scope.isProductList) {
          $scope.$emit('reload-arts-page')
        } else if (info && info.changed && $scope.isProductList) {
          $scope.$emit('refresh-arts-page', { sectionId: info.in, targetId: info.to })
        }

        return info.changed
      })
    })
  }

  function _unarchiveArt (template) {
    function _unarchiveArtCallback () {
      return ArtsService.unarchiveArt(template.id).then(() => {
        if (template.isTemplate) {
          SegmentService.track('arts-template-archive')
        }
        $scope.$emit('reload-arts-page', { emitter: 'unarchiveTemplate' })

        $timeout(() => {
          ToastService.defaultSuccessToast()
        }, 200, false)
      })
    }

    if (template.isTemplate) {
      return api._moveToClick(template, true, true).then(changed => {
        if (changed) {
          return _unarchiveArtCallback()
        }
      })
    } else {
      return _unarchiveArtCallback()
    }
  }

  function _archiveArt (template) {
    ArtsService.archiveArt(template.id).then(() => {
      if ($scope.templateParam) {
        $scope.templateParam.id = template.id
      }
      if (!template.isTemplate) {
        SegmentService.track('archive-art', {
          artId: template.id,
          isUnavailable: template.unavailable
        })
      }
      if ($scope.isProductList) {
        $scope.$emit('refresh-arts-page', { sectionId: template.artCollectionId })
      } else {
        $scope.$emit('reload-arts-page', { emitter: 'archiveTemplate', sectionId: template.artCollectionId })
      }
      $timeout(() => {
        ToastService.defaultSuccessToast()
      }, 200, false)
    }).catch(ToastService.defaultErrorToast)
  }

  function _isBluefitDesigner () {
    if ($scope.isPublicCampaign) return false
    return +$rootScope.oUser.customerCompanyId === 604 && $rootScope.isUserDesigner()
  }
  $scope.isBluefitDesigner = _isBluefitDesigner

  function _isOutdated (template, actionFunction, actionType) {
    const temporarilyAvailable = template.temporarilyAvailable?.length ? template.temporarilyAvailable[0] : null
    const isDownload = actionType === 'download'
    const isShare = actionType === 'share'
    const isDuplicate = actionType === 'duplicate'

    if (!api._isBluefitDesigner() && (template.isTemplate === true || $rootScope.isUserSysAdminAdminDesigner())) {
      actionFunction(template)
      return
    }

    if (template.templateHasUpdate) {
      api._showOutdatedDialog(template)
    } else if (template.unavailable && template.approvalStatus === 'PENDING_REWORK' && actionType === 'editor') {
      actionFunction(template)
    } else if (temporarilyAvailable && (isDownload || isShare || isDuplicate)) {
      if (isDownload && !temporarilyAvailable.downloaded) {
        actionFunction(template)
      } else if (isShare && !temporarilyAvailable.shared) {
        actionFunction(template)
      } else {
        api._showUnavailableDialog(template)
      }
    } else if (template.unavailable) {
      api._showUnavailableDialog(template)
    } else {
      ArtsService.getInfosBusinessData(template.id).then((res) => {
        if (res.hasUpdate) {
          MessageService.warning({
            title: $translate.instant('outdatedBusinessUnitDialog.title'),
            text: $translate.instant('outdatedBusinessUnitDialog.message'),
            cancelButton: $translate.instant('cancel'),
            confirmButton: $translate.instant('continueDownload'),
            closeOnConfirm: true,
            press: () => {
              actionFunction(template)
            }
          })
        } else {
          actionFunction(template)
        }
      }).catch(() => {
        // Fallback to normal download if the business data check fails
        actionFunction(template)
      })
    }
  }

  $scope.isOutdated = (template, action, actionType) => _isOutdated(template, action, actionType)

  function _showOutdatedDialog (art) {
    api.getOutdatedTemplateDialogController().then(({ OutdatedTemplateDialogController }) => {
      return ModalService.showModal({
        templateId: 'outdatedTemplate.html',
        templateUrl: '/arts/dialogs/outdated-template/outdated-template-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: OutdatedTemplateDialogController,
        data: { art }
      })
    })
  }

  function _showUnavailableDialog (art) {
    api.getUnavailableTemplateDialogController().then(({ UnavailableTemplateDialogController }) => {
      return ModalService.showModal({
        templateId: 'unavailableTemplate.html',
        templateUrl: '/arts/dialogs/unavailable-template/unavailable-template-dialog.html?$$REVISION$$',
        destroyable: true,
        observers: true,
        allowMultiple: true,
        controller: UnavailableTemplateDialogController
      })
    }).then(shouldArchive => {
      if (shouldArchive) {
        $scope.archiveTemplateClick(art)
      }
    })
  }

  $scope.redirect = function () {
    $state.go('arts.collection', { id: $scope.template.artCollectionId })
  }

  function _applyWrapButtons () {
    $timeout(() => {
      $scope.isWrapButton = false

      const actionBtnsElement = $attrs.$$element.find('.hover-action-btns')[0]
      const iconButtonsLength = actionBtnsElement?.childElementCount

      if (iconButtonsLength >= 4) {
        $scope.isWrapButton = true
      }
    }, 300, true)
  }

  $scope.handleCardClick = function (template, event) {
    if ($scope.checkbox && !event.target.closest('.hover-action-btns') && !event.target.closest('.selection-btn') && !event.target.closest('.asset-selection-btn')) {
      $scope.change({ template })
    }

    if ($scope.onCardClick) {
      $scope.onCardClick({ template, event })
    }
  }
}
